module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"pageTitle":"SGPix by Stefano Guindani Photo","pageMetaDescription":"Acquista le foto degli eventi"}}')
  delete Component.options._Ctor
}
